<template>
    <view>
        <div class="topadsbox">
        <div class="container topads_box">
            <div id="headeradsone" class="carousel slide" data-bs-ride="carousel">
                <!-- 幻灯片/轮播 -->
                <div class="carousel-inner index_ads">
                    <div v-for="(item,index) in headeradsone" :key="index"  class="carousel-item" :class="index==0?'active':''">
                        <a :href="item.link?item.link:'#'">
                        <img :src="'https://www.ynqjnews.net'+item.image" :title="item.name" class="topadsimg">
                        </a>
                    </div>
                </div>
            </div>                
        </div>
        <div class="container topmargin">
            <div class="row">
                <div class="col-xs-12 col-sm-3 b_right" style="padding-right:3px;">
                    <!-- 轮播 -->
                    <div id="headeradsleft" class="carousel slide" data-bs-ride="carousel">
                        <!-- 幻灯片/轮播 -->
                        <div class="carousel-inner index_ads">
                            <div v-for="(items,key) in headeradsleft" :key="key"  class="carousel-item" :class="key==0?'active':''">
                                <a :href="items.link?items.link:'#'" target="_blank">
                                <img :src="'https://www.ynqjnews.net'+items.image" :title="items.name" class="topadsimg">
                                </a>
                            </div>
                        </div>
                    </div>                
                </div>
                <div class="col-xs-12 col-sm-6 topmargin">
                    <!-- 轮播 -->
                    <div id="headeradscenter" class="carousel slide" data-bs-ride="carousel">
                        <!-- 幻灯片/轮播 -->
                        <div class="carousel-inner index_ads">
                            <div v-for="(items,key) in headeradscenter" :key="key"  class="carousel-item" :class="key==0?'active':''">
                                <a :href="items.link?items.link:'#'" target="_blank">
                                <img :src="'https://www.ynqjnews.net'+items.image" :title="items.name" class="topadsimg">
                                </a>
                            </div>
                        </div>
                    </div>                
                </div>
                <div class="col-xs-12 col-sm-3 b_left topmargin" style="padding-left:3px;">
                    <!-- 轮播 -->
                    <div id="headeradsright" class="carousel slide" data-bs-ride="carousel">
                        <!-- 幻灯片/轮播 -->
                        <div class="carousel-inner index_ads">
                            <div v-for="(items,key) in headeradsright" :key="key"  class="carousel-item" :class="key==0?'active':''">
                                <a :href="items.link?items.link:'#'" target="_blank">
                                <img :src="'https://www.ynqjnews.net'+items.image" :title="items.name" class="topadsimg">
                                </a>
                            </div>
                        </div>
                    </div>                
                </div>
            </div>
        </div>
    </div>
    </view>
</template>
<script>
    import { post } from '../request'; 
    export default {
        name: 'TopAds',
        data() {
            return {
                headeradsone:[],
                headeradsleft:[],
                headeradscenter:[],
                headeradsright:[],
            }
        },
        created() {
            this.getHeaderadsone()
            this.getHeaderadsleft()
            this.getHeaderadscenter()
            this.getHeaderadsright()
        },
        methods: {
            async getHeaderadsone() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/14', postData);  
                    //console.log(response)
                    that.headeradsone = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getHeaderadsleft() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/15', postData);  
                    //console.log(response)
                    that.headeradsleft = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getHeaderadscenter() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/16', postData);  
                    //console.log(response)
                    that.headeradscenter = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
            async getHeaderadsright() {  
                let that = this
                try {  
                    const postData = {};  
                    const response = await post('page/banner/17', postData);  
                    //console.log(response)
                    that.headeradsright = response
                } catch (error) {  
                    console.error('数据获取失败', error);  
                }  
            },  
 
        },
    }
</script>
<style scoped>
.topadsbox{
    background:#ffffff; padding-bottom:15px;
}
.topadsimg{ height: 90px; width: 100%;}
.topads_box{margin-top:0px; }
.topmargin{ margin: 0px auto 0px auto;}
.col-xs-12 col-sm-3 b_right{ padding-right: 3px!important;}
.col-xs-12 col-sm-3 b_left{ padding-left: 3px!important;}
@media(max-width:767px){
    .topadsbox{
    background:#ffffff; padding-bottom:0px; display: none;
}
    .topads_box{margin-top:0px; margin: 0px; padding:0px;}
    .topadsimg{ height: auto; width: 100%;}
    .topmargin{ margin-top:5px; padding: 0px;}
}
</style>
  